import { c as _c } from "react/compiler-runtime";
import { useTheme } from "@mui/material";
import { getNodeColors } from "#/shared/lib";
export const useNodeColors = (color, t0) => {
  const $ = _c(4);
  const useDefaultPrimary = t0 === undefined ? true : t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== color || $[1] !== theme || $[2] !== useDefaultPrimary) {
    t1 = getNodeColors(theme, color, useDefaultPrimary);
    $[0] = color;
    $[1] = theme;
    $[2] = useDefaultPrimary;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};